import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core'
import { RouterService } from '../services/router/router.service'
import { UserService } from '../services/user/user.service'
import { ModalService } from '../services/modal/modal.service'
import { LoginAlertDialogComponent } from '../common/modals/login-alert-dialog/login-alert-dialog.component'
import { KakaoService } from '../services/kakao/kakao.service'

@Directive({
  selector: '[requireLogin]',
})
export class RequireLoginDirective {
  @Input() title: string | undefined
  @Input() description: string | undefined
  @Input() action: Function | undefined

  constructor(
    private userService: UserService,
    private routerService: RouterService,
    private modalService: ModalService,
    private kakaoService: KakaoService
  ) {}

  @HostListener('click', ['$event'])
  async handleClick(event: Event) {
    event.preventDefault()

    if (this.userService.isLoggedIn) {
      if (this.action) {
        this.action()
      }
      return
    }

    const loginAlert = await this.modalService.openDialog(LoginAlertDialogComponent, {
      title: this.title,
      description: this.description,
    })
    await loginAlert.present()
    const { data } = await loginAlert.onWillDismiss()
    if (data) {
      this.kakaoService.login(location.pathname)
    }
  }
}
